/**
 * @module app.prospection.wallet.createBDCFirstStepCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function CreateBDCFirstStepCtrl($scope, $uibModalInstance, clientService, $log, marketService, orderTypeService) {
        var self = {};

        self.clients = [];
        self.isSearchLoading = false;
        self.searchedClient = null;
        self.orderTypeService = orderTypeService;
        self.orderType = self.orderTypeService.getOrderTypeByCode('TRAD');
        self.markets = marketService.getMarkets();
        self.market = marketService.getMarketByCode('TABACPRESSE');
        self.hasBeenSearched = false;
        self.isLadditionAlone = false;
        self.isMudetaf = false;

        self.selectedFilter = '';
        self.storeFilters = [
            { state: '', label: 'Tout' },
            { state: 0, label: 'Pré-client' },
            { state: 1, label: 'Client' },
            { state: 2, label: 'Ancien client' },
            { state: 3, label: 'Prospect' },
            { state: 4, label: 'Ancien Propriétaire' },
            { state: 5, label: 'Attente Reprise' }
        ];
        self.selectedNetworkFilter = '';
        self.networkFilters = [
            { state: '', label: 'Tout' },
            { state: '300', label: 'Bimedia' },
            { state: '302', label: 'Devlyx' },
        ]

        self.ok = function(client) {
            $uibModalInstance.close({
                client: client,
                orderMarket: self.market,
                orderType: self.orderType,
                isMultiStores: self.isMultiStores,
                isLadditionAlone: self.isLadditionAlone
            });
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        /**
         * Search clients according to a research
         */
        self.searchClient = function searchClient() {
            if (!self.searchedClient || self.searchedClient === '') {
                return;
            }
            self.isSearchLoading = true;
            self.hasBeenSearched = true;

            clientService
                .searchClient(self.searchedClient)
                .then(function(clients) {
                    self.clients = clients;
                })
                .catch(function(err) {
                    $log.error(err);
                })
                .finally(function() {
                    self.isSearchLoading = false;
                });
        };

        /**
         * Change the market type
         * @param  {String} type example: TABACPRESSE or BOULANGERIE
         */
        self.changeOrderMarket = function changeOrderMarket(marketTypeCode) {
            self.market = marketService.getMarketByCode(marketTypeCode);
        };

        /**
         * Change the order type
         * @param  {String} type : NAP, TRAD or FLORAJET
         */
        self.changeOrderType = function changeOrderType(type) {
            self.orderType = self.orderTypeService.getOrderTypeByCode(type);
        };


        self.createClient = function createClient() {
            self.ok(null);
        };

        return self;
    }

    CreateBDCFirstStepCtrl.$inject = [
        '$scope',
        '$uibModalInstance',
        'clientService',
        '$log',
        'marketService',
        'orderTypeService'
    ];

    angular
        .module('app.prospection.wallet.createBDCFirstStepCtrl', ['ui.bootstrap.modal'])
        .controller('CreateBDCFirstStepCtrl', CreateBDCFirstStepCtrl);
});
